<template src="./Services.component.html"></template>
<style type="text/css" src="./Services.component.css"></style>

<script>
import Slick from 'vue-slick';
export default {
  name: 'Services',
  components: {
    Slick
  },
  data () {
    return {
      slickOptions: {
        slidesToShow: 2,
        vertical: true,
        touchMove: true,
        swipeToSlide: true,
        slidesToScroll: 1,
        pauseOnHover: true,
        pauseOnFocus: true,
        infinite: true,
        draggable: false,
        dots: false,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000,
        centerPadding: '0px'
          // Any other options that can be got from plugin documentation
      },
      firstCardHover: false,
      secondCardHover: false,
      thirdCardHover: false,
      fourthCardHover: false,
      fifthCardHover: false,
      sixthCardHover: false
    }
  },
  methods: {
    next() {
        this.$refs.slick.next();
    },

    prev() {
        this.$refs.slick.prev();
    },

    reInit() {
        // Helpful if you have to deal with v-for to update dynamic lists
        this.$nextTick(() => {
            this.$refs.slick.reSlick();
        });
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Services/Services.component.vue